import { Alert } from '@mui/material'
import { format } from 'date-fns'

import { DRIVER_APP_FULFILMENT_RELIABLE_FROM_DATE } from 'components/reports/Metrics/constants/DriverAppFulfilment'
import { useGetDriverAppFulfilmentReliableFromDateQuery } from 'generated/graphql'

interface Props {
  start: Date | null
}

// Shown whenever the selected period reaches back before posting dates were recorded. The
// threshold comes from the "Driver App Fulfilment - posting dates reliable from" app setting
// (Settings -> Global Variables), so each environment carries its own go-live date; the built-in
// constant covers the moment while the setting loads or when it is missing. The banner's month is
// derived from whichever value is in effect, so text and threshold can never disagree.
export const DriverAppFulfilmentHistoryNote = ({ start }: Props) => {
  const { data } = useGetDriverAppFulfilmentReliableFromDateQuery()

  const configured = data?.driverAppFulfilmentReliableFromDate
  const reliableFrom = configured ? new Date(configured) : DRIVER_APP_FULFILMENT_RELIABLE_FROM_DATE

  if (start == null || start >= reliableFrom) {
    return null
  }

  const reliableFromMonth = format(reliableFrom, 'MMMM yyyy')

  return (
    <Alert severity='info'>
      {`Jobs posted before ${reliableFromMonth} may be under-represented. Posting dates were not ` +
        'recorded before this point and can only be recovered for some historical jobs. As a ' +
        'result, Driver App fulfilment rates for earlier periods may appear lower than they ' +
        'actually were.'}
    </Alert>
  )
}
